import { render, staticRenderFns } from "./GridButton.vue?vue&type=template&id=06cbb9fb&scoped=true"
import script from "./GridButton.vue?vue&type=script&lang=ts"
export * from "./GridButton.vue?vue&type=script&lang=ts"
import style0 from "./GridButton.vue?vue&type=style&index=0&id=06cbb9fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbb9fb",
  null
  
)

export default component.exports